import { report, reportAndNavigateTo } from './google_analytics'

const MAX_DELAY = 2000

interface IDataSet {
  gaEvent?: string
  gaCategory?: string
  gaAction?: string
  gaLabel?: string
}

function onSubmit(e: Event) {
  const form = e.target as HTMLFormElement
  const data = form.dataset as IDataSet

  if (data.gaEvent !== 'submit') {
    return
  }

  if (data.gaCategory == null || data.gaAction == null) {
    console.error(
      'Error: reporting to google analytics requires both category and action attributes'
    )
    return
  }

  e.preventDefault()

  const timeoutId = setTimeout(() => form.submit(), MAX_DELAY)
  report(data.gaCategory, data.gaAction, data.gaLabel).then(() => {
    clearTimeout(timeoutId)
    form.submit()
  })
}

function onClick(e: Event) {
  const el = e.target as HTMLElement
  const data = el.dataset as IDataSet

  if (data.gaEvent == null || (data.gaEvent !== 'click' && data.gaEvent !== '')) {
    return
  }

  if (data.gaCategory == null || data.gaAction == null) {
    console.error(
      'Error: reporting to google analytics requires both category and action attributes'
    )
    return
  }

  if (el.tagName === 'A' && el.getAttribute('target') === '_blank') {
    e.preventDefault()
    const url = el.getAttribute('href') || location.hash || '#'
    reportAndNavigateTo(url, data.gaCategory, data.gaAction, data.gaLabel)
  } else {
    report(data.gaCategory, data.gaAction, data.gaLabel)
  }
}

export default function initializeEventReporter() {
  document.addEventListener('submit', onSubmit)
  document.addEventListener('click', onClick)
}
